import axios from 'axios'
import { MessageBox } from 'element-ui'
import qs from 'qs'
axios.defaults.headers.common['Cache-Control'] = 'no-cache'
axios.defaults.headers.common['Pragma'] = 'no-cache'
let isShowIngError = false
axios.interceptors.response.use(function ({data, config, status}) {
  if (config.responseType === 'blob') {
    return Promise.resolve(data)
  }
  data.result = data.result || data.code
  if (status) {
    return Promise.resolve(data.data)
  } else {
    return new Promise((resolve, reject) => {
      if (!isShowIngError) {
        isShowIngError = true
        MessageBox({
          title: '请求错误',
          message: data.error,
          type: 'error',
          closeOnClickModal: false,
          callback: function (action) {
            if (action === 'confirm') {
              isShowIngError = false
              reject(data.error)
            } else if (action === 'cancel') {
              isShowIngError = false
            }
          }
        })
      }
    })
  }
})

const timeout = 800000
export default {
  get (url, params = {}, config = {}) {
    return axios({
      method: 'GET',
      url,
      params,
      timeout: timeout,
      ignoreErrorModal: config.ignoreErrorModal || false,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      },
      ...config
    })
  },
  post (url, data, config = {}) {
    return axios({
      method: 'POST',
      url: url,
      data: qs.stringify(data, {arrayFormat: 'brackets'}),
      timeout: timeout,
      ignoreErrorModal: config.ignoreErrorModal || false,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      ...config
    })
  },
  postByJson (url, data, config = {}) {
    return axios({
      method: 'POST',
      url: url,
      data: JSON.stringify(data),
      timeout: timeout,
      ignoreErrorModal: config.ignoreErrorModal || false,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json; charset=UTF-8'
      }
    })
  },
  upload (url, params, config) {
    let formData = new FormData()
    Object.keys(params).forEach(function (key) {
      formData.append(key, params[key])
    })
    return axios.post(url, formData, config)
  },
  getFile (url, data = null) {
    return axios({
      method: 'post',
      responseType: 'blob',
      url: url,
      data: qs.stringify(data)
    })
  }
}



// WEBPACK FOOTER //
// ./src/helper/api.js